export const DEFAULT_CUSTOMER_TYPE = "regular";
export const DEFAULT_THEME = "default";
export const DEFAULT_LANGUAGE = "en";
export const DEFAULT_CUSTOMER_ID_LABEL = "Customer ID";

export const SOURCE_STRING_SEPARATOR = "_";

export const CUSTOMER_ID_SESSION_KEY = "userId";
export const CUSTOMER_EMAIL_SESSION_KEY = "emailId";
export const CUSTOMER_NAME_SESSION_KEY = "userName";
export const CUSTOMER_TEL_SESSION_KEY = "userTel";

export const CALENDAR_DATE_FORMAT = "YYYY-MM-DD";
export const TIME_FORMAT = "hh:mm a";
export const DATE_FORMAT = "DD/MM/YYYY, dddd";

export const MORNING_SLOT = "Morning";
export const AFTERNOON_SLOT = "Afternoon";
export const MAX_ALLOWED_PEOPLE = 2;
export const MIN_ALLOWED_PEOPLE = 1;

export const QRCODE_ACTIVE_STATUS = "active";
export const QRCODE_EXPIRED_STATUS = "expired";
export const QRCODE_CANCELLED_STATUS = "cancelled";
export const QRCODE_CHECKEDIN_STATUS = "checkedin";
export const QRCODE_CHECKEDOUT_STATUS = "checkedout";

export const BAD_REQUEST_ERROR_TITLE = "400: Bad Request";

export const BOOKING_ERRORS = {
  USER_ALREADY_HAS_BOOKING: "USER_ALREADY_HAS_BOOKING",
  CUSTOMER_ALREADY_IN_MALL: "CUSTOMER_ALREADY_IN_MALL",
  NO_SLOT_AVAILABLE: "NO_SLOT_AVAILABLE",
  NO_CURRENT_SLOT_AVAILABLE: "NO_CURRENT_SLOT_AVAILABLE",
  SERVICE_TYPE_NOT_AVAILABLE: "SERVICE_TYPE_NOT_AVAILABLE",
  BOOKING_LIMIT_EXCEEDED: "BOOKING_LIMIT_EXCEEDED",
};

export const ADOBEDTM_PAGE_NAME = {
  CT_Additional_Data_Collection: "CT - Additional Data Collection",
  CT_Service_and_Slot_Selection: "CT - Service and Slot Selection",
  CT_Display_Bookings: "CT - Display Bookings",
  Turnero_Display_Tokens: "Turnero - Display Tokens",
  Home_Page: "Home Page",
  Loggedin_User: "Loggedin User",
  Turnero_Confirmation: "Turnero - Confirmation",
  Booking_Selection: "Booking Selection",
  CT_Store_in_mall_Selection: "CT - Mall,Store,Store in mall Selection",
  CT_Store_Selection: "CT - Store Selection",
  Turnero_Store_Service_Selection: "Turnero - Store and Service Selection",
  CT_Confirmation: "CT - Confirmation",
};

export const getIDToSet = (country) => {
  switch (country) {
    case "MX":
      return "customerPhoneNumberWithoutCode";
    default:
      return "userId";
  }
};
